import classNames from 'classnames'
import BSCard from 'react-bootstrap/Card'

import Card from '@/components/Card/Card'
import { PageCardType } from '@/types/card'

import styles from './CardPanel.module.scss'

type Props = {
  card: PageCardType
  className?: string
}

const CardPanel = ({ card, className }: Props) => (
  <BSCard className={classNames(styles.container, className, 'shadow-sm')}>
    <Card card={{ ...card, url: card.url || '' }} fullCard={card} />
  </BSCard>
)

export default CardPanel
